import client from './token_client'

export const sendMagicLink = (redirectUrl, email, locale) => {
  return client.post('chromebot/sign_in_link', {
    redirect_url: redirectUrl,
    email,
    locale
  })
}

export const getMagicLink = email => {
  return client.get('chromebot/sign_in_link', {
    params: {
      email
    }
  })
}
